module.exports = __webpack_public_path__ + "assets/img/97925e3ab0626a21ebbc56d2b14ff680.png";